//設定箇所 start

  //================================================================
  //【共通設定】すべての日付・時間帯に共通する設定
  //================================================================
  var limitTime = "23:59"; //受注締め時間 これを跨いだ場合、各minDayに1日加算されます 未設定は"23:59"にする
  var timezoneoffset = -9; // UTC-表示したいタイムゾーン(単位:hour) JSTなら-9
  var WeekChars = [ "日", "月", "火", "水", "木", "金", "土" ];
  // プルダウンの表示設定
  var pullDownAddWeekDay = true;//日付選択プルダウンに曜日を追加して表示 trueなら表示falseなら非表示
  var pullDownAddHead = true;//日付選択に"指定無し"を追加する trueなら表示falseなら非表示
  var pullDownAddHeadtxt = "指定無し";//指定をしない際のテキスト
  var pullDownAddYear = true;//日付選択に年を追加する trueなら表示falseなら非表示

  //================================================================
  //【仕上がり希望日用】設定
  //================================================================
  var minDay = 0;//現在日時からこの数値をプラスして選択可能な最短日数 本日が1/1で設定が1なら最短は1/2（締め時間超過時は+1）
  var maxListSize = 50;//最短日数から起算して選択可能な最大日数 本日が1/1で設定が10なら最大日は1/10 締め時間,不可曜日,不可日付があった場合、最大リストから除去する形になる
                       //※注意点 数値を伸ばし過ぎると閲覧者の利用端末によっては動作が重くなります 100以内に収めてください
  var noSendWeekDaylist = ['']; //選択不可能な曜日 生成したリストから該当の曜日を除去して表示 ''で曜日を囲み複数ある場合はカンマで繋ぐ
  var noSendDaylist = ['']; //選択不可能な日MM/DD形式で指定

  //================================================================
  //【ご支給予定日用】設定
  //================================================================
  var provideMinDay = 0;//現在日からプラスして選択可能な最短日数（締め時間超過時は+1）
  var provideMaxListSize = 50;//最短日から起算して候補に出す最大日数（100以内推奨）
  var noProvideWeekDaylist = ['土','日']; //選択不可能な曜日
  var noProvideDaylist = ['10/12','11/03','11/23','12/28','12/29','12/30','12/31']; //選択不可能な日MM/DD形式で指定

  //================================================================
  //【お引き取り希望日・時間帯用】設定
  //================================================================
  var pickupMinDay = 0;      //現在日からプラスして選択可能な最短日数（締め時間超過時は+1）
  var pickupMaxListSize = 50; //最短日から起算して候補に出す最大日数（100以内推奨）
  var noPickupWeekDaylist = ['土','日']; //選択不可能な曜日（土日は休業のため除外）
  var noPickupDaylist = ['10/12','11/03','11/23','12/28','12/29','12/30','12/31']; //選択不可能な日（祝日など）MM/DD形式で指定 例:['01/01','01/13']
  // 希望時間帯（1時間刻みで生成）
  var pickupTimeStartHour = 9;  //開始時刻（時）
  var pickupTimeEndHour = 17;   //終了時刻（時）※この時刻の手前までを1時間刻みで生成（9〜17で 9:00-10:00 … 16:00-17:00）

//設定箇所 end


//設定したタイムゾーンに併せた現在日時を取得
  var fakeUTC = new Date(Date.now() - (timezoneoffset * 60 - new Date().getTimezoneOffset()) * 60000);
  var year = fakeUTC.getFullYear();
  var month = fakeUTC.getMonth()+1;
  var date = fakeUTC.getDate();
  var hour = fakeUTC.getHours();
  var min = fakeUTC.getMinutes();
  var second = fakeUTC.getSeconds();


  //起動
  window.addEventListener('DOMContentLoaded', function(){
    var today = getToday();//現在日の取得
    var now = getNow();//現在日時の取得
    try {//配送締め時間の取得
      var deadlineHour = limitTime.split(':')[0];
      var deadlineMinute = limitTime.split(':')[1];
      var deadlineTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), deadlineHour, deadlineMinute);
    } catch(e) {
      console.log(e);
      deadlineTime = today;//指定方法に不備があった場合は現在日時が締め時間
    }
    var pastDeadline = now.getTime() > deadlineTime.getTime();//締め時間を超えたか
    if(pastDeadline){//締め時間を超えた場合に1日加算
      minDay++;
    }
    var deliveryBaseDay = new Date(now.setDate(now.getDate() + minDay));//仕上がり希望日の最短日付
    var deliveryBaseList = createList(deliveryBaseDay, maxListSize);//仕上がり専用の候補日数で生成
    // 配送希望日のリスト作成（配送用設定を除外）
    var deliveryList = delSendDay(delSendWeekDay(deliveryBaseList, noSendWeekDaylist), noSendDaylist);

    // ご支給予定日のリスト作成（ご支給専用の最短日数・候補日数を使用）
    var provideMinDayCalc = provideMinDay + (pastDeadline ? 1 : 0);//締め時間超過時は+1
    var provideNow = getNow();//now は上で破壊的に変更済みのため再取得
    var provideBaseDay = new Date(provideNow.setDate(provideNow.getDate() + provideMinDayCalc));//ご支給最短日
    var provideBaseList = createList(provideBaseDay, provideMaxListSize);//ご支給専用の候補日数で生成
    var provideList = delSendDay(delSendWeekDay(provideBaseList, noProvideWeekDaylist), noProvideDaylist);

    // お引き取り希望日のリスト作成（お引き取り専用の最短日数・候補日数を使用）
    var pickupMinDayCalc = pickupMinDay + (pastDeadline ? 1 : 0);//締め時間超過時は+1
    var pickupNow = getNow();//now は上で破壊的に変更済みのため再取得
    var pickupBaseDay = new Date(pickupNow.setDate(pickupNow.getDate() + pickupMinDayCalc));//お引き取り最短日
    var pickupBaseList = createList(pickupBaseDay, pickupMaxListSize);//お引き取り専用の候補日数で生成
    var pickupList = delSendDay(delSendWeekDay(pickupBaseList, noPickupWeekDaylist), noPickupDaylist);

    // 配送希望日のプルダウン作成
    createPullDown('deliveryDate', 'dumyDeliveryDate', deliveryList, '指定無し');
    // ご支給予定日のプルダウン作成
    createPullDown('provideDate', 'dumyProvideDate', provideList, '日付を選択してください');
    // お引き取り希望日のプルダウン作成
    createPullDown('pickupDate', 'dumyPickupDate', pickupList, '日付を選択してください');
    // お引き取り希望時間帯のプルダウン作成（9時〜17時を1時間ごと）
    createPickupTimePullDown('pickupTime', 'dumyPickupTime', '時間帯を選択してください');

  })

  //お引き取り希望時間帯のプルダウン作成（1時間刻み）
  function createPickupTimePullDown(selectId, dummyId, headText){
    var select = document.getElementById(selectId);
    if (!select) return; // 該当IDが画面に存在しない場合は処理をスキップ

    var dummyEl = document.getElementById(dummyId);
    var defaultVal = dummyEl ? dummyEl.value : '';
    select.innerHTML = ''; // 既存の選択肢をクリア

    // 先頭の案内項目
    var head = document.createElement('option');
    head.setAttribute('value', '');
    head.innerHTML = headText || '時間帯を選択してください';
    select.appendChild(head);

    for(var h = pickupTimeStartHour; h < pickupTimeEndHour; h++){
      var range = h + ':00-' + (h + 1) + ':00';
      var option = document.createElement('option');
      option.setAttribute('value', range);
      option.innerHTML = range;
      if(option.value == defaultVal){
        option.selected = true;
      }
      select.appendChild(option);
    }
  }

 //リストから指定の曜日を除去する
 function delSendWeekDay(selectList, weekList){
    var targetWeekList = weekList || noSendWeekDaylist;
    var delAfterList = [];
    var skipFlg=false;//初期値
    for (var i=0; i< selectList.length; i++) {
     skipFlg=false;//初期化
     var wDay= selectList[i].getDay();//曜日の取得
      WeekChars[wDay];
      for(var j=0; j< targetWeekList.length; j++){
         if(WeekChars[wDay] == targetWeekList[j]){
           skipFlg=true;
         }
      }
      if(!skipFlg){
         delAfterList.push(selectList[i]);
      }
    }
     return delAfterList;
    }

  //リストから指定日付の除去
  function delSendDay(selectList, dayList){
    var targetDayList = dayList || noSendDaylist;
    var delAfterList = [];
    var noSendDay;
    var targetDay;
    var skipFlg=false;
    for (var i=0; i< selectList.length; i++) {
      skipFlg=false;
      targetDay = new Date(2001+'/'+(selectList[i].getMonth()+1)+'/'+selectList[i].getDate())
      for(var j=0; j< targetDayList.length; j++){
        noSendDay = new Date(2001+'/'+targetDayList[j]);
        if(targetDay.getTime() == noSendDay.getTime()){
            skipFlg=true;
        }
      }
      if(!skipFlg){
        delAfterList.push(selectList[i]);
      }
    }
    return delAfterList;
  }
  
  //基本日付リストの作成
  //listSize を省略した場合は共通設定の maxListSize を使用（後方互換）
  function createList(minDay, listSize){
    var size = (typeof listSize === 'number') ? listSize : maxListSize;
    var selectList = [];
    var targetDay = minDay;
    for (var i=0; i< size; i++) {
     targetDay = new Date(minDay);
     targetDay = new Date(targetDay.setDate(targetDay.getDate() + i));
     selectList.push(targetDay);
    }
    return selectList;
  }
  
  //現在日の取得(タイムゾーンで指定された日)
  function getToday(){
    var today = new Date(year+"/"+month+"/"+date);
    return today;
  }
  
  //現在日時の取得(タイムゾーンで指定された時間)
  function getNow(){
    var now = new Date(year+"/"+month+"/"+date+" "+hour+":"+min);
    return now;
  }
  
  //プルダウンに曜日追加
  function pullDownAddWeekDay(){
    //曜日追加
    var w = ["日","月","火","水","木","金","土"];
    var deliveryDateSelectOption = $('select#SEND_HOPE_DATE option');
    for (var i=0; i<=deliveryDateSelectOption.length; i++) {
        if(i!=0){
            var optDatext = $(deliveryDateSelectOption[i]);
            var optionDateWeekDay = new Date($(optDatext).text());
            var optionDateWeekDayW = w[optionDateWeekDay.getDay()];
            $(optDatext).text( $(optDatext).text()+" ("+optionDateWeekDayW+")");
            }
        }
  }
  
  //プルダウンの作成
  function createPullDown(selectId, dummyId, selectList, headText){
    var targetDate;
    var wDay='';
    var targetWeekDay = '';    
    var select = document.getElementById(selectId);
    if (!select) return; // 該当IDが画面に存在しない場合は処理をスキップ

    var dummyEl = document.getElementById(dummyId);
    var defaultVal = dummyEl ? dummyEl.value : '';
    select.innerHTML = ''; // 既存の選択肢をクリア

    var option = document.createElement('option');
    if(pullDownAddHead){//指定なし等の先頭項目を追加
      option.setAttribute('value', '');
      option.innerHTML = headText || pullDownAddHeadtxt;
      select.appendChild(option);
    }
    for(var i=0; i< selectList.length; i++){
      option = document.createElement('option');
      targetDate='';
      targetWeekDay='';
      targetDate = ketaume((selectList[i].getMonth()+1),2)+'-'+ ketaume(selectList[i].getDate(),2);
      option.setAttribute('value', selectList[i].getFullYear()+'-'+targetDate);//valueをセット yyyy-mm-dd形式
      targetDate=targetDate.replace(/-/g,'/');
       if(pullDownAddYear){//年を追加する場合
        targetDate = selectList[i].getFullYear()+'/'+targetDate;
      }
      if(pullDownAddWeekDay){//曜日を追加する場合
        wDay= selectList[i].getDay();
        targetDate=targetDate+" ("+WeekChars[wDay]+")";
      }
      option.innerHTML = targetDate;
      if(option.value == defaultVal){
        option.selected = true;
      }
      select.appendChild(option);
    }
  }
  
  //桁埋めを行う
  function ketaume(num,digit){
    if(digit < 1)
        return num; 
    var ketaumeStr = '0';
    var zero = '';
    
    for(var i=1; i<digit; i++){
        zero += ketaumeStr;
    }
    var result = ( zero + num ).slice( -digit );
    return result;
  }